import React, { useEffect, useState } from 'react';
import { Box, Text, VStack, useColorModeValue } from '@chakra-ui/react';

interface RecollectionPayload {
  recollectionLeadIn: string;
  recollectionText: string;
  connectionType: string;
  approximateTimeframe?: string;
}

export function SoftMemory() {
  const [memory, setMemory] = useState<RecollectionPayload | null>(null);
  const [loading, setLoading] = useState(true);

  const isEnabled = process.env.REACT_APP_LEXI_MEMORY_GRAPH_ENABLED === '1';

  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('pink.100', 'pink.900');

  useEffect(() => {
    if (!isEnabled) return;
    
    async function fetchMemory() {
      try {
        
        // Note: For mock purposes, directly hitting the mock endpoint
        const res = await fetch(`http://localhost:9000/lex/memory/recollection`);
        if (res.ok) {
          const data = await res.json();
          setMemory(data);
        }
      } catch (err) {
        console.error('Failed to fetch recollection memory:', err);
      } finally {
        setLoading(false);
      }
    }
    
    fetchMemory();
  }, [isEnabled]);

  if (!isEnabled || loading || !memory) {
    return null; // Do not render if disabled, loading, or failed
  }

  return (
    <Box 
      p={4} 
      borderWidth="1px" 
      borderColor={borderColor} 
      borderRadius="xl" 
      bg={cardBg}
      shadow="sm"
      maxW="sm"
    >
      <VStack align="start" spacing={1}>
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          {memory.recollectionLeadIn}
        </Text>
        <Text fontSize="md" fontWeight="medium">
          "{memory.recollectionText}"
        </Text>
        {memory.approximateTimeframe && (
          <Text fontSize="xs" color="gray.400" alignSelf="flex-end">
            — {memory.approximateTimeframe}
          </Text>
        )}
      </VStack>
    </Box>
  );
}

export default SoftMemory;
